<template>
  <div class="ion-margin-top report-component">
    <!-- START Textarea item -->
    <ion-item>
      <ion-label v-if="placeholders && placeholders[0]" position="floating">
        {{ placeholders[0] }}
      </ion-label>
      <ion-label v-else position="floating">Saisir...</ion-label>

      <ion-textarea
        rows="4"
        maxlength="2000"
        :disabled="disabled"
        :value="value"
        @ionChange="$emit('update:value', $event.detail.value)"
      ></ion-textarea>
    </ion-item>
  </div>
</template>

<script>
import { IonItem, IonTextarea, IonLabel } from '@ionic/vue';

export default {
  name: 'Textarea',

  components: {
    IonTextarea,
    IonItem,
    IonLabel,
  },

  props: {
    title: String,
    value: String,
    placeholders: Array,
    disabled: Boolean,
  },

  emits: ['update:value'],
};
</script>
